import { BAYS } from '../../../../../constants';

import type { Bays } from '../../../../../utils/types';

interface StartBtSupervisionButtonDisabledParams {
  btSupervisionId: string | undefined;
  clientId: number | null | undefined;
  timeToolTipOpen: boolean;
  durationToolTipOpen: boolean;
  bayActiveAtDateTime: Bays | undefined;
}

export function isBay6Active(bayActiveAtDateTime: Bays | undefined): boolean {
  return bayActiveAtDateTime === BAYS.BAY_6;
}

export function isStartBtSupervisionButtonDisabled(
  params: StartBtSupervisionButtonDisabledParams,
): boolean {
  const { btSupervisionId, clientId, timeToolTipOpen, durationToolTipOpen, bayActiveAtDateTime } =
    params;

  return (
    btSupervisionId !== 'new' ||
    !clientId ||
    timeToolTipOpen ||
    durationToolTipOpen ||
    isBay6Active(bayActiveAtDateTime)
  );
}
